const shared = require('./shared');

export default shared.theme;
